import { suggestKeywords as suggestFromText } from "@hub/matching";

/**
 * Keyword suggestions for a need or an offer. The matching package keeps the phrases a person wrote ("tax
 * accountant", "r&d credits") ahead of single words, so the same list the server would derive is what the chips show.
 */
export function suggestKeywords(title: string, description = "", max = 15): string[] {
  return suggestFromText(title, description, max);
}

export function normaliseKeyword(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, " ");
}
